import Color from '../Color.mjs'
import superMeta from '../_PRODUCT/metaProductNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.CYAN,
    codeProp: 'aoNo',
    detailUrl: '/AoDetail',
    detailIdProp: 'aoId',
    listUrl: '/AoList',
    mapProp: 'aoMap',
    name: '分析对象',
    textProp: 'aoName',
    type: 'AO',
}
